// MWFContext.js
import React, { createContext, useContext, useState } from 'react';

// Create a context to store and provide the selected MWF value
const MWFContext = createContext();

export const MWFProvider = ({ children }) => {
  // State for the selected MWF
  const [selectedMWF, setSelectedMWF] = useState('');

  return (
    <MWFContext.Provider value={{ selectedMWF, setSelectedMWF }}>
      {children}
    </MWFContext.Provider>
  );
};

// Custom hook to access the MWF context
export const useMWF = () => useContext(MWFContext);
